<template>
  <Field class="block" :rules="rules" as="div" :name="name"
         :label="label"
  >
    <p class="mb-1 font-captions text-captions text-black">
      {{ label }}<span v-if="fieldIsRequired && (typeof hideAsterisk === 'undefined' || hideAsterisk === false)">*</span>
    </p>

    <slot />

    <ErrorMessage as="div"
                  :name="name"
                  class="mt-4 font-captions text-captions text-error"
    />
  </Field>
</template>
<script>
import {ErrorMessage, Field} from "vee-validate";

export default {
  props: ['label', 'name', 'rules', 'hideAsterisk'],

  components: {
    ErrorMessage,
    Field,
  },

  computed: {
    fieldIsRequired() {
      return typeof this.rules !== 'undefined' && this.rules !== null && this.rules.includes('required')
    },
  }
}
</script>
